export interface UserListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  partner_id?: number[] | null;
  search?: string | null;
  role?: string | null;
}

export const defaultUserListFilter: UserListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  partner_id: null,
  search: '',
  role: '',
};
